/* AFIQ redesign · Reviews (/pages/review): per-deck ratings, featured verified-buyer quotes, band price tokens.
   Loaded with defer by sections/afiq-reviews-main + afiq-reviews-band (guarded, runs once), after afiq-shop.js. */
(function () {
  'use strict';
  if (window.__afiqReviewsInit || !window.AFIQ_UI) return;
  window.__afiqReviewsInit = true;
  /* Price/tier tokens, filled from live AFIQ data (never hard-coded). Same helper in afiq-contact/faq/filmroom/quiz/reviews.js. */
  function afiqFill(html) {
    var U = window.AFIQ_UI, A = window.AFIQ, P = U.P, $ = U.$, L = A.LADDER || [];
    var vols = U.VOLS, e = U.priceDecks(vols), top = L[L.length - 1] || { min: 0, pct: 0 };
    var cards = vols.reduce(function (s, id) { return s + (+P[id].cards || 54); }, 0);
    var ladder = function (unit) {
      return L.map(function (t, i) {
        var nx = L[i + 1], label = !nx ? t.min + ' or more' : (nx.min - 1 > t.min ? t.min + '–' + (nx.min - 1) + ' decks' : t.min + ' decks');
        var price = unit ? ' (' + $(A.unitCents(t.min)) + (i === 0 ? ' each' : '') + ')' : '';
        return label + ' ' + t.pct + '%' + (i === 0 ? ' off' : '') + price;
      }).join(', ');
    };
    var map = {
      elite_total: $(e.total), elite_full: $(e.full), elite_save: $(e.save), elite_cards: String(cards),
      ladder: ladder(true), ladder_short: ladder(false),
      top_min: String(top.min), top_pct: String(top.pct), top_unit: $(A.unitCents(top.min)),
      volumes: vols.map(function (d) { return '<b>' + U.esc(P[d].label) + ': ' + U.esc(P[d].title) + '</b>: ' + U.esc(P[d].hook); }).join('<br>'),
      fl5_hook: P.fl5 ? U.esc(P.fl5.hook) : ''
    };
    return String(html)
      .replace(/\{basics_discounted:([^|}]*)\|([^}]*)\}/g, function (m, yes, no) { return U.basicsDiscounted ? yes : no; })
      .replace(/\{pct_(\d+)\}/g, function (m, n) { return String(A.tier(+n).pct); })
      .replace(/\{unit_(\d+)\}/g, function (m, n) { return $(A.unitCents(+n)); })
      .replace(/\{([a-z0-9_]+)\}/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; });
  }
  function afiqFillAll(root) {
    root = root || document;
    root.querySelectorAll('[data-afiq-tpl]').forEach(function (el) { el.innerHTML = afiqFill(el.getAttribute('data-afiq-tpl')); });
    root.querySelectorAll('[data-afiq-fill]').forEach(function (el) { el.innerHTML = afiqFill(el.innerHTML); });
  }

  afiqFillAll();
  var root = document.querySelector('[data-afiq-reviews]');
  if (!root) return;
  var U = window.AFIQ_UI, P = U.P, esc = U.esc;

  /* Featured: Judge.me verified buyers only (reviews.featured is verified-only), one per author, word for word. */
  var seen = {}, picks = [];
  ['v1', 'v2', 'v3', 'v4', 'fl5', 'basics'].forEach(function (id) {
    if (!P[id]) return;
    ((P[id].reviews || {}).featured || []).forEach(function (r) {
      if (r && r.author && !seen[r.author] && (!r.on || r.on === P[id].label)) { seen[r.author] = 1; picks.push({ r: r, on: r.on || P[id].label }); }
    });
  });
  var list = root.querySelector('[data-rv-list]');
  if (list) list.innerHTML = picks.map(function (x) {
    var r = x.r;
    return '<div class="rv"><span class="stars" aria-label="' + (+r.score || 5) + ' out of 5 stars">' + U.stars(r.score) + '</span><p>“' + esc(r.text) + '”</p><div class="rv-f"><b>' + esc(r.author) + '</b><span class="vb">' + U.I.check + 'Verified buyer</span><span>' + esc(x.on) + '</span></div></div>';
  }).join('');

  var by = root.querySelector('[data-rv-by]');
  if (by) by.innerHTML = ['v1', 'v2', 'v3', 'v4', 'fl5', 'basics'].map(function (id) {
    var p = P[id], r = p && p.reviews; if (!r || !r.count) return '';
    return '<li><a href="' + esc(p.url) + '"><img src="' + esc(p.cutout_sm || p.cutout) + '" alt="" width="18" height="26" loading="lazy"><span>' + esc(p.short) + '</span><b>' + Number(r.avg).toFixed(1) + '</b><em>' + Number(r.count).toLocaleString() + '</em></a></li>';
  }).join('');
})();
